var render = function render(_c, _vm) {
  return _c(
    "wa-question-and-answer",
    { attrs: { id: "changes", title: "How can I find out about changes?" } },
    [
      _c("template", { slot: "copy" }, [
        _c("p", [
          _vm._v(
            "\n      This version of Font Awesome's privacy questions and answers took effect\n      "
          ),
          _c("time", { attrs: { datetime: _vm.props.lastUpdated } }, [
            _vm._v(_vm._s(_vm.props.lastUpdatedFormatted)),
          ]),
          _vm._v(".\n    "),
        ]),
        _vm._v(" "),
        _c(
          "p",
          [
            _vm._v(
              "\n      Font Awesome will post the next version at\n      "
            ),
            _c("site-link", { attrs: { to: { name: "privacy" } } }, [
              _vm._v("https://fontawesome.com/privacy"),
            ]),
            _vm._v(
              ". Font Awesome may change how it announces changes in future versions.\n      In the meantime, Font Awesome may update\n      "
            ),
            _c("site-link", { attrs: { to: { hash: "#contact" } } }, [
              _vm._v("its contact information"),
            ]),
            _vm._v("\n      and\n      "),
            _c("site-link", { attrs: { to: { hash: "#sharing" } } }, [
              _vm._v("list of service providers"),
            ]),
            _vm._v(
              "\n      without announcing a change. Please refer to\n      "
            ),
            _c("site-link", { attrs: { to: { name: "privacy" } } }, [
              _vm._v("https://fontawesome.com/privacy"),
            ]),
            _vm._v("\n      for the latest information at any time.\n    "),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }